const padTwo = (number) => {
    if (number < 10) {
        return '0' + number;
    }

    return number;
}

/**
 * Convert date to a human readable format.
 * @param {Date} dateObject The date object to be formatted
 * @param {Boolean} isTimestamp if it is a timestamp value
 * @param {Boolean} short if true show short format
 */
export default (dateObject, isTimestamp = false, short = false) => {
    if (isTimestamp)
        dateObject = new Date(dateObject);

    try {
        const hour = dateObject.getHours() % 12 === 0 ? 12 : dateObject.getHours() % 12;
        const am = dateObject.getHours() < 12 ? 'am' : 'pm';
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const day = dateObject.getDate();
        let month = dateObject.getMonth();
        let year = dateObject.getFullYear();

        if (!short)
            switch (month) {
                case 0:
                    month = "Enero";
                    break;
                case 1:
                    month = "Febrero";
                    break;
                case 2:
                    month = "Marzo";
                    break;
                case 3:
                    month = "Abril";
                    break;
                case 4:
                    month = "Mayo";
                    break;
                case 5:
                    month = "Junio";
                    break;
                case 6:
                    month = "Julio";
                    break;
                case 7:
                    month = "Agosto";
                    break;
                case 8:
                    month = "Septiembre";
                    break;
                case 9:
                    month = "Octubre";
                    break;
                case 10:
                    month = "Noviembre";
                    break;
                case 11:
                    month = "Diciembre";
                    break;
                default:
            }

        if (!short)
            return `${hour}:${padTwo(minutes)}:${padTwo(seconds)}${am} - ${day} de ${month} ${year}`;

        return `${hour}:${padTwo(minutes)}${am} ${month + 1}/${day}/${year}`;
    } catch (err) {
        console.error("The object is not a date");
    }
}

/**
 * Convert date to a human readable format.
 * @param {Date} dateObject The date object to be formatted
 * @param {Boolean} isTimestamp if it is a timestamp value
 * @param {Boolean} short if true show short format
 */
export const getUTCTime = (dateObject, isTimestamp = false, short = false, fullTime = false) => {
    if (isTimestamp)
        dateObject = new Date(dateObject);

    try {
        const hour = dateObject.getUTCHours() % 12 === 0 ? 12 : dateObject.getUTCHours() % 12;
        const am = dateObject.getUTCHours() < 12 ? 'am' : 'pm';
        const minutes = dateObject.getUTCMinutes();

        const day = dateObject.getUTCDate();
        let month = dateObject.getUTCMonth();
        let year = dateObject.getUTCFullYear();

        if (!short)
            switch (month) {
                case 0:
                    month = "Enero";
                    break;
                case 1:
                    month = "Febrero";
                    break;
                case 2:
                    month = "Marzo";
                    break;
                case 3:
                    month = "Abril";
                    break;
                case 4:
                    month = "Mayo";
                    break;
                case 5:
                    month = "Junio";
                    break;
                case 6:
                    month = "Julio";
                    break;
                case 7:
                    month = "Agosto";
                    break;
                case 8:
                    month = "Septiembre";
                    break;
                case 9:
                    month = "Octubre";
                    break;
                case 10:
                    month = "Noviembre";
                    break;
                case 11:
                    month = "Diciembre";
                    break;
                default:
            }

        if (!short) {
            if (fullTime)
                return `${hour}:${padTwo(minutes)}${am} ${day} de ${month} ${year}`;
            else
                return `${day} de ${month} ${year}`;
        }

        if (fullTime)
            return `${hour}:${padTwo(minutes)}${am} ${month + 1}/${day}/${year}`;
        else
            return `${month + 1}/${day}/${year}`;
    } catch (err) {
        console.error("The object is not a date");
    }
}

/**
 * Convert timestamp to hours format hh:mm:ss am.
 * @param {Number} timestamp The timestamp
 */
export const getTime = (timestamp, includeSeconds = false) => {
    const dateObject = new Date(timestamp);

    try {
        const hour = dateObject.getHours() % 12 === 0 ? 12 : dateObject.getHours() % 12;
        const am = dateObject.getHours() < 12 ? 'am' : 'pm';
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();

        if (includeSeconds)
            return `${hour}:${padTwo(minutes)}:${padTwo(seconds)}${am}`;
        else
            return `${hour}:${padTwo(minutes)}${am}`;
    } catch (err) {
        console.error("The object is not a date");
    }
}

/**
 * Convert timestamp to date format mm/dd/yyyy.
 * @param {Number} timestamp The timestamp
 */
export const getDate = (timestamp) => {
    const dateObject = new Date(timestamp);

    try {
        const day = dateObject.getDate();
        let month = dateObject.getMonth() + 1;
        let year = dateObject.getFullYear();

        return `${month}/${day}/${year}`;
    } catch (err) {
        console.error("The object is not a date");
    }
}